module.exports = __webpack_public_path__ + "img/img-flow-3-2.e75fe76f.png";